export default {
  hpTopImg: require("./logo.svg"),
  hpMiddleImg: require("./home-visuel-vc.jpg"),
  ouestFranceImg: require("./ouest-france.png"),
  logoBotImg: require("./logo-bot.png"),
};
